module.exports = __webpack_public_path__ + "static/logo_black-41dafd3c43b0112f1cee9efe98644375.png";